module.exports = __webpack_public_path__ + "50bc3a3cc8cea71662f0c708131f3ecb.pdf";